import "./tarifsSumery.css";
import TarfisSumeryEntry from "./tarifsSumeryEntry";

function TarifsSumery() {
  return (
    <div className="tarifs-sumery-contenair">
      <div className="tarifs-sumery-title">
        <h1>DÉTAILS DES PRESTATIONS</h1>
      </div>
      <div className="tarifs-sumery-warning">
        Pour plus d'information veuillez consulter ce site depuis un ordinateur.
      </div>
      <div className="tarifs-sumery-main">
        <div className="tarifs-sumery-main2">
          <div className="tarifs-sumery-header">
            <div className="sumery-header-titleA">PRESTATIONS</div>
            <div className="sumery-header-titleB">PRIX</div>
            <div className="sumery-header-titleC">À DOMICILE / EN ATELIER</div>
          </div>
          <TarfisSumeryEntry
            name="DIAGNOSTIC"
            price="20€ TTC"
            domicile="✅"
            atelier="✅"
          />
          <TarfisSumeryEntry
            name="CHANGEMENT DE COMPOSANT"
            price="10€ à 30€ TTC + Pièce"
            domicile="❌"
            atelier="✅"
          />
          <TarfisSumeryEntry
            name="DÉSINFECTION VIRUS ET MALWARES"
            price="40€ TTC"
            domicile="✅"
            atelier="✅"
          />
          <TarfisSumeryEntry
            name="DÉPOUSSIÈRAGE"
            price="40€ TTC"
            domicile="✅"
            atelier="✅"
          />
          <TarfisSumeryEntry
            name="ACCÉLÉRATION DU SYSTÈME"
            price="40€ TTC"
            domicile="✅"
            atelier="✅"
          />
          <TarfisSumeryEntry
            name="INSTALLATION DU SYSTÈME D'EXPLOITATION"
            price="40€ TTC"
            domicile="✅"
            atelier="✅"
          />
          <TarfisSumeryEntry
            name="RECONDITIONNEMENT"
            price="100€ TTC"
            domicile="❌"
            atelier="✅"
          />
          <TarfisSumeryEntry
            name="CONSEIL ACHAT INFORMATIQUE"
            price="20€ TTC"
            domicile="✅"
            atelier="✅"
          />
          <TarfisSumeryEntry
            name="MONTAGE PC SUR MESURE / GAMING"
            price="À partir de 50€ TTC"
            domicile="✅"
            atelier="✅"
          />
          <TarfisSumeryEntry
            name="CONTRATS DE MAINTENANCE"
            price="À partir de 80€ TTC"
            domicile="✅"
            atelier="✅"
          />
          <TarfisSumeryEntry
            name="DÉVELOPPEMENT LOGICIEL"
            price="Sur devis"
            domicile="❌"
            atelier="✅"
          />
          <TarfisSumeryEntry
            name="DÉVELOPPEMENT SITE WEB"
            price="Sur devis"
            domicile="❌"
            atelier="✅"
          />
        </div>
      </div>
    </div>
  );
}

export default TarifsSumery;
